import styled from "styled-components";

export const ClientProductWrapper = styled.div``;
